<div class="styles-panel" *ngIf="!loading">
    <div class="styles-section">
        <h4 translate="TC.Common.Style" *ngIf="!layerEditMode"></h4>
        <div class="attribute-based-symbology-checkbox" *ngIf="!layerEditMode || template.id">
            <gsp-checkbox
                [(value)]="template.enableAttributedSymbols"
                [id]="'enableAttributedSymbols'"
                [label]="'TCS.Mapviewer.LayerSymbology.EnableAttributeBasedSymbology' | translate"
            ></gsp-checkbox>
            <gsp-help-text
                [text]="'TCS.Mapviewer.LayerSymbology.AttributeBasedSymbology.Info' | translate"
            ></gsp-help-text>
        </div>

        <ng-container *ngIf="template.id || !layerEditMode">
            <!-- Line and Area templates-->
            <ng-container *ngIf="template.geometryType !== GeometryTypes.POINT">
                <ng-container *ngIf="template.geometryType === GeometryTypes.LINE">
                    <div class="sub-heading">
                        {{ 'TC.Common.Line' | translate }}
                    </div>

                    <div class="styles-item-group">
                        <label translate="TCS.Mapviewer.LayerSymbology.LineStyle"></label>
                        <gsp-dropdown
                            name="lineStyle"
                            [options]="lineStyleOptions"
                            [overlapMenuOn]="true"
                            [(ngModel)]="templateStyle.lineStyle"
                            idField="name"
                            textField="label"
                            [addIcon]="true"
                            id="lineStyleDropdown"
                        ></gsp-dropdown>
                    </div>
                    <div *ngIf="!template.enableAttributedSymbols">
                        <ng-container *ngTemplateOutlet="defaultStyle"></ng-container>
                    </div>
                </ng-container>

                <ng-container *ngIf="template.geometryType === GeometryTypes.AREA">
                    <div class="sub-heading">
                        {{ 'TC.Common.Area' | translate }}
                    </div>

                    <div class="styles-item-group">
                        <label translate="TCS.Mapviewer.LayerSymbology.LineStyle"></label>
                        <gsp-dropdown
                            name="lineStyle"
                            [options]="lineStyleOptions"
                            [overlapMenuOn]="true"
                            [(ngModel)]="templateStyle.lineStyle"
                            idField="name"
                            textField="label"
                            [addIcon]="true"
                            id="lineStyleDropdown"
                        ></gsp-dropdown>
                    </div>
                    <div *ngIf="!template.enableAttributedSymbols">
                        <ng-container *ngTemplateOutlet="defaultStyle"></ng-container>
                    </div>
                    <div class="styles-item-group">
                        <label translate="TCS.Mapviewer.LayerSymbology.FillOpacity"></label>
                        <gsp-number
                            [type]="GspNumberType.GENERIC"
                            [max]="100"
                            [min]="0"
                            (keyup)="validatePercentage($event)"
                            (blur)="validatePercentage($event)"
                            [(ngModel)]="templateStyle.fillOpacity"
                            autoComplete="off"
                            id="polygonOpacity"
                        ></gsp-number>
                        <span class="percentage-icon">%</span>
                    </div>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="template.geometryType !== GeometryTypes.LINE">
                <!-- Temporarily hide the symbol section for line templates (TCMAPS-4525) -->
                <div *ngIf="template.geometryType !== GeometryTypes.AREA" class="sub-heading">
                    {{ 'TCS.ModelDefinitionEditor.Symbol' | translate }}
                </div>
                <div *ngIf="template.geometryType === GeometryTypes.LINE" class="enable-symbols-checkbox">
                    <gsp-checkbox
                        [(value)]="template.enableSymbols"
                        [id]="'enableSymbols'"
                        [label]="'TCS.Mapviewer.LayerSymbology.EnableSymbols' | translate"
                        (valueChange)="symbolTypeSelected(this.templateStyle.symbol.type)"
                    ></gsp-checkbox>
                    <gsp-help-text
                        [text]="'TCS.Mapviewer.LayerSymbology.EnableSymbols.Info' | translate"
                    ></gsp-help-text>
                </div>
            </ng-container>

            <!-- Common for all Geometry Types -->
            <ng-container *ngIf="template.enableSymbols">
                <div class="styles-item-group type-dropdown">
                    <label translate="TC.Common.Type"></label>
                    <gsp-dropdown
                        name="symbolType"
                        [options]="layerSymbolTypes"
                        [overlapMenuOn]="true"
                        [(ngModel)]="this.templateStyle.symbol.type"
                        idField="name"
                        textField="label"
                        (ngModelChange)="symbolTypeSelected($event)"
                    ></gsp-dropdown>
                </div>
                <div class="styles-item-group shape-dropdown">
                    <label translate="TCS.ModelDefinitionEditor.SymbolFields.Shape"></label>
                    <gsp-dropdown
                        name="symbolShape"
                        [options]="layerSymbolShapes"
                        [overlapMenuOn]="true"
                        [(ngModel)]="templateStyle.symbol.symbolName"
                        idField="name"
                        textField="label"
                        [addIcon]="true"
                        [overlapMenuOn]="true"
                        (ngModelChange)="symbolShapeSelected($event)"
                    ></gsp-dropdown>
                </div>
                <div
                    *ngIf="this.templateStyle.symbol.type === LayerSymbologyType.CUSTOMIZABLE"
                    class="styles-item-group"
                >
                    <label translate="TC.Common.Text"></label>
                    <gsp-text
                        id="symbolCustomText"
                        required="true"
                        length="2"
                        [placeholder]="'TCS.Mapviewer.LayerSymbology.Customizable.TextPreview' | translate"
                        [(ngModel)]="templateStyle.symbol.text"
                        errorTooltipMsg="{{ getErrorText() | translate }}"
                    ></gsp-text>
                </div>
                <div *ngIf="!template.enableAttributedSymbols">
                    <ng-container *ngTemplateOutlet="defaultStyle; context: { isSymbolSection: true }"></ng-container>
                </div>
            </ng-container>
            <ng-container *ngIf="!template.enableAttributedSymbols">
                <div class="styles-item-group">
                    <label translate="TC.Common.Preview"></label>
                </div>
                <symbology-preview
                    [geometryType]="template.geometryType"
                    [templateStyle]="templateStyle"
                    [template]="template"
                ></symbology-preview>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="!template.id && layerEditMode">
            <!--Show only single color selection for imported layers-->
            <!--Remove this entire section and the ng-container wrapper in the above block once Vector Layers are available on TF-->

            <div *ngIf="template.geometryType === GeometryTypes.POINT" class="styles-item-group">
                <label translate="TC.Common.Color"></label>
                <gsp-color-picker-rgb
                    [colorValue]="templateStyle.symbol.fillColor"
                    (selectedColor)="setColorForImportedLayer($event)"
                ></gsp-color-picker-rgb>
            </div>
            <div *ngIf="template.geometryType === GeometryTypes.LINE" class="styles-item-group">
                <label translate="TC.Common.Color"></label>
                <gsp-color-picker-rgb
                    [colorValue]="templateStyle.lineColor"
                    (selectedColor)="setColorForImportedLayer($event)"
                ></gsp-color-picker-rgb>
            </div>
            <div *ngIf="template.geometryType === GeometryTypes.AREA" class="styles-item-group">
                <label translate="TC.Common.Color"></label>
                <gsp-color-picker-rgb
                    [colorValue]="templateStyle.fillColor"
                    (selectedColor)="setColorForImportedLayer($event)"
                ></gsp-color-picker-rgb>
            </div>
        </ng-container>
    </div>

    <div class="attribute-based-symbology styles-section">
        <ng-container *ngIf="template.enableAttributedSymbols">
            <div class="sub-heading">
                {{ 'TCS.Mapviewer.LayerSymbology.AttributeBasedSymbology' | translate }}
            </div>
            <gsp-notification
                *ngIf="template.enableAttributedSymbols && !this.templateStyle.styleOverrides?.length"
                [type]="NotificationType.Info"
                id="style-overrides-empty-error"
                ><div>
                    {{ styleOverrideEmptyMessage | translate }}
                </div>
            </gsp-notification>
            <div class="attribute-based-symbology-dropdown">
                <label translate="TCS.Mapviewer.LayerSymbology.AttributeBasedSymbology.ChoiceFieldTitle"></label>
                <gsp-dropdown
                    name="attributeChoiceField"
                    [options]="templateChoiceFieldOptions"
                    [overlapMenuOn]="true"
                    [(ngModel)]="attributeChoiceFieldId"
                    textField="label"
                    (ngModelChange)="choiceFieldSelected($event)"
                ></gsp-dropdown>
            </div>
            <div *ngIf="attributeChoiceFieldId" class="attribute-based-symbology-dropdown">
                <label translate="TCS.Mapviewer.LayerSymbology.AttributeBasedSymbology.ChoiceOverrides"></label>
                <gsp-dropdown
                    name="selectedChoiceOverrides"
                    [options]="selectedChoiceOverrideOptions"
                    [overlapMenuOn]="true"
                    [(ngModel)]="selectedChoiceOverrideId"
                    textField="label"
                    [ngDisabled]="!selectedChoiceOverrideOptions.length"
                    [minimumSearchLimit] = "100"
                ></gsp-dropdown>
            </div>
            <gsp-button
                [hidden]="!attributeChoiceFieldId"
                (action)="addOverride()"
                [type]="ButtonType.Default"
                text="{{ 'TCS.Mapviewer.LayerSymbology.AttributeBasedSymbology.AddOverride' | translate }}"
                [disabled]="!selectedChoiceOverrideId"
            ></gsp-button>

            <div class="attribute-overrides-list-container">
                <div *ngFor="let item of templateStyle.styleOverrides" class="attribute-overrides-list-item">
                    <div class="attribute-overrides-list-item-header">
                        <div class="sub-heading">
                            {{ getChoiceDisplayValue(item) }}
                        </div>
                        <gsp-button
                            class="remove-user-button"
                            [type]="ButtonType.Icon"
                            [iconClass]="'icon_line_close_24 i24'"
                            (action)="removeOverrideFromList(item)"
                        ></gsp-button>
                    </div>

                    <div *ngIf="template.geometryType !== GeometryTypes.POINT" class="styles-item-group">
                        <label translate="TCS.Mapviewer.LayerSymbology.LineColor"></label>
                        <gsp-color-picker-rgb
                            [colorValue]="item.lineColor"
                            (selectedColor)="item.lineColor = $event"
                        ></gsp-color-picker-rgb>
                    </div>
                    <ng-container *ngIf="templateStyle.symbol.type !== LayerSymbologyType.CUSTOMIZABLE">
                        <div
                            *ngIf="
                                template.geometryType !== GeometryTypes.LINE ||
                                (template.enableAttributedSymbols && template.enableSymbols)
                            "
                            class="styles-item-group"
                        >
                            <label translate="TCS.Mapviewer.LayerSymbology.FillColor"></label>
                            <gsp-color-picker-rgb
                                [colorValue]="item.fillColor"
                                (selectedColor)="item.fillColor = $event"
                            ></gsp-color-picker-rgb>
                        </div>
                        <div *ngIf="template.geometryType === GeometryTypes.POINT" class="styles-item-group">
                            <label translate="TCS.Mapviewer.LayerSymbology.OutlineColor"></label>
                            <gsp-color-picker-rgb
                                [colorValue]="item.outlineColor"
                                (selectedColor)="item.outlineColor = $event"
                            ></gsp-color-picker-rgb>
                        </div>
                    </ng-container>
                    <div
                        *ngIf="templateStyle.symbol.type === LayerSymbologyType.CUSTOMIZABLE"
                        class="styles-item-group"
                    >
                        <label translate="TC.Common.Color"></label>
                        <gsp-color-picker-rgb
                            [colorValue]="item.color"
                            (selectedColor)="item.color = $event; item.outlineColor = $event"
                        ></gsp-color-picker-rgb>
                    </div>
                </div>
            </div>

            <div class="all-others">
                <div class="sub-heading">
                    {{ 'TCS.Mapviewer.LayerSymbology.AttributeBasedSymbology.AllOthers' | translate }}
                </div>
                <ng-container *ngTemplateOutlet="defaultStyle"></ng-container>
            </div>
        </ng-container>
    </div>
</div>

<loading class="loading-align-center" *ngIf="loading"></loading>

<ng-template #defaultStyle let-isSymbolSection="isSymbolSection">
    <!-- Point -->
    <ng-container *ngIf="template.geometryType === GeometryTypes.POINT">
        <ng-container *ngIf="this.templateStyle.symbol.type !== LayerSymbologyType.CUSTOMIZABLE">
            <div class="styles-item-group">
                <label translate="TCS.Mapviewer.LayerSymbology.FillColor"></label>
                <gsp-color-picker-rgb
                    [colorValue]="templateStyle.symbol.fillColor"
                    (selectedColor)="templateStyle.symbol.fillColor = $event"
                ></gsp-color-picker-rgb>
            </div>
            <div class="styles-item-group">
                <label translate="TCS.Mapviewer.LayerSymbology.OutlineColor"></label>
                <gsp-color-picker-rgb
                    [colorValue]="templateStyle.symbol.outlineColor"
                    (selectedColor)="templateStyle.symbol.outlineColor = $event"
                ></gsp-color-picker-rgb>
            </div>
        </ng-container>
    </ng-container>

    <!-- Line and Area -->
    <ng-container *ngIf="template.geometryType !== GeometryTypes.POINT">
        <div
            *ngIf="
                isSymbolSection &&
                template.enableSymbols &&
                this.templateStyle.symbol.type !== LayerSymbologyType.CUSTOMIZABLE
            "
            class="styles-item-group"
        >
            <label translate="TCS.Mapviewer.LayerSymbology.FillColor"></label>
            <gsp-color-picker-rgb
                [colorValue]="templateStyle.symbol.fillColor"
                (selectedColor)="templateStyle.symbol.fillColor = $event"
            ></gsp-color-picker-rgb>
        </div>
        <div *ngIf="!isSymbolSection" class="styles-item-group">
            <label translate="TCS.Mapviewer.LayerSymbology.LineColor"></label>
            <gsp-color-picker-rgb
                [colorValue]="templateStyle.lineColor"
                (selectedColor)="templateStyle.lineColor = $event"
            ></gsp-color-picker-rgb>
        </div>
        <div
            *ngIf="
                template.geometryType === GeometryTypes.LINE &&
                !isSymbolSection &&
                template.enableSymbols &&
                template.enableAttributedSymbols &&
                this.templateStyle.symbol.type !== LayerSymbologyType.CUSTOMIZABLE
            "
            class="styles-item-group"
        >
            <label translate="TCS.Mapviewer.LayerSymbology.FillColor"></label>
            <gsp-color-picker-rgb
                [colorValue]="templateStyle.symbol.fillColor"
                (selectedColor)="templateStyle.symbol.fillColor = $event"
            ></gsp-color-picker-rgb>
        </div>
        <div *ngIf="template.geometryType === GeometryTypes.AREA" class="styles-item-group">
            <label translate="TCS.Mapviewer.LayerSymbology.FillColor"></label>
            <gsp-color-picker-rgb
                [colorValue]="templateStyle.fillColor"
                (selectedColor)="templateStyle.fillColor = $event"
            ></gsp-color-picker-rgb>
        </div>
    </ng-container>

    <ng-container
        *ngIf="
            this.template.geometryType !== GeometryTypes.AREA &&
            this.templateStyle.symbol.type === LayerSymbologyType.CUSTOMIZABLE &&
            (isSymbolSection || template.enableAttributedSymbols)
        "
    >
        <div class="styles-item-group">
            <label translate="TC.Common.Color"></label>
            <gsp-color-picker-rgb
                [colorValue]="templateStyle.symbol.color"
                (selectedColor)="templateStyle.symbol.color = $event; templateStyle.symbol.outlineColor = $event"
            ></gsp-color-picker-rgb>
        </div>
    </ng-container>
</ng-template>
